import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `FinancingTypeProduct/Delete/${id}`, method: 'DELETE', body: null, token: token })
}
